import { loadScript, releaseScript } from '../../../browser/ScriptLoader';
import { META_PIXEL_SCRIPT_SRC, type MetaFbq } from './types';

type WindowWithFbq = Window & { fbq?: MetaFbq; _fbq?: MetaFbq };

function getWindow(): WindowWithFbq | null {
  return typeof window !== 'undefined' ? (window as WindowWithFbq) : null;
}

function ensureFbqStub(): MetaFbq {
  const win = getWindow();
  if (!win) throw new Error('[MetaScriptLoader] window unavailable');
  if (win.fbq) return win.fbq as MetaFbq;

  const fbq = function (...args: unknown[]) {
    const fn = fbq as MetaFbq;
    if (fn.callMethod) {
      fn.callMethod(...args);
    } else {
      (fn.queue = fn.queue || []).push(args);
    }
  } as MetaFbq;

  fbq.push = fbq;
  fbq.loaded = false;
  fbq.version = '2.0';
  fbq.queue = [];

  win.fbq = fbq;
  if (!win._fbq) win._fbq = fbq;

  return fbq;
}

export class MetaScriptLoader {
  private loaded = false;

  async load(timeoutMs = 10_000): Promise<MetaFbq> {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      throw new Error('[MetaScriptLoader] Browser APIs unavailable');
    }

    const fbq = ensureFbqStub();
    if (this.loaded && fbq.loaded) return fbq;

    await loadScript({
      src: META_PIXEL_SCRIPT_SRC,
      id: 'pixel-v2-meta-fbevents',
      timeoutMs,
    });

    fbq.loaded = true;
    this.loaded = true;
    return fbq;
  }

  release(): void {
    releaseScript(META_PIXEL_SCRIPT_SRC);
  }
}
